define(["exports", "react", "styled-components", "../../atoms", "./assets/-1.png", "./assets/1.png", "./assets/2.png", "./assets/3.png"], function (_exports, _react, _styledComponents, _atoms, _, _2, _3, _4) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  _ = _interopRequireDefault(_);
  _2 = _interopRequireDefault(_2);
  _3 = _interopRequireDefault(_3);
  _4 = _interopRequireDefault(_4);

  var CardCVStyled = _styledComponents.default.div.withConfig({
    displayName: "MiniCV__CardCVStyled",
    componentId: "sc-11o5kch-0"
  })(["border-bottom:solid 1px ", ";display:flex;padding:16px;position:relative;text-align:left;transition:background 0.2s ", ";width:100%;"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.gray;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.easing.ease;
  });

  var ImgStyled = _styledComponents.default.div.withConfig({
    displayName: "MiniCV__ImgStyled",
    componentId: "sc-11o5kch-1"
  })(["margin-right:16px;position:relative;"]);

  var InfosStyled = _styledComponents.default.div.withConfig({
    displayName: "MiniCV__InfosStyled",
    componentId: "sc-11o5kch-2"
  })(["display:inline-block;"]);

  var NameStyled = (0, _styledComponents.default)(_atoms.P).withConfig({
    displayName: "MiniCV__NameStyled",
    componentId: "sc-11o5kch-3"
  })(["font-weight:", ";line-height:1.7;margin:0;"], function (_ref3) {
    var theme = _ref3.theme;
    return theme.font.semibold;
  });

  var BoldName = _styledComponents.default.span.withConfig({
    displayName: "MiniCV__BoldName",
    componentId: "sc-11o5kch-4"
  })(["font-weight:", ";"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.font.semibold;
  });

  var StyledPcd = _styledComponents.default.span.withConfig({
    displayName: "MiniCV__StyledPcd",
    componentId: "sc-11o5kch-5"
  })(["background-color:", ";border-radius:12px;color:", ";display:flex;font-size:1.4em;font-weight:", ";line-height:24px;margin:8px 0 0;max-width:85px;padding:0 16px;box-icon{fill:", ";height:24px;padding:0 8px 0 0;width:24px;}"], function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.blue;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.white;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.font.semibold;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.white;
  });

  var Visualized = _styledComponents.default.span.withConfig({
    displayName: "MiniCV__Visualized",
    componentId: "sc-11o5kch-6"
  })(["background-color:", ";border-radius:50%;display:none;height:6px;position:absolute;right:16px;top:24px;width:6px;"], function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.darkGray;
  });

  var ReactionStyled = _styledComponents.default.span.withConfig({
    displayName: "MiniCV__ReactionStyled",
    componentId: "sc-11o5kch-7"
  })(["position:absolute;right:-10px;top:20px;z-index:30;"]);

  var RecommendedTag = (0, _styledComponents.default)(_atoms.Small).withConfig({
    displayName: "MiniCV__RecommendedTag",
    componentId: "sc-11o5kch-8"
  })(["background-color:", ";border-radius:2px;color:", ";display:inline-block;font-weight:", ";margin:16px 0 0 0;padding:4px 8px 4px 40px;position:relative;box-icon{left:8px;position:absolute;top:2px;fill:", ";}"], function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.lightGray;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.colors.dark;
  }, function (_ref12) {
    var theme = _ref12.theme;
    return theme.font.semibold;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.colors.dark;
  });
  var rating = [{
    value: 3,
    image: _4.default
  }, {
    value: 2,
    image: _3.default
  }, {
    value: 1,
    image: _2.default
  }, {
    value: -1,
    image: _.default
  }];

  var MiniCV = function MiniCV(_ref14) {
    var _salario_atual$valor, _acoes$marcadores;

    var _ref14$miniCVData = _ref14.miniCVData,
        nome = _ref14$miniCVData.nome,
        ultima_experiencia = _ref14$miniCVData.ultima_experiencia,
        ultimo_curso = _ref14$miniCVData.ultimo_curso,
        nivel_de_escolaridade = _ref14$miniCVData.nivel_de_escolaridade,
        salario_atual = _ref14$miniCVData.salario_atual,
        pcd = _ref14$miniCVData.pcd,
        acoes = _ref14$miniCVData.acoes,
        dentro_do_perfil = _ref14$miniCVData.dentro_do_perfil,
        candidatura = _ref14$miniCVData.candidatura,
        avatarURL = _ref14.avatarURL,
        currentLocale = _ref14.currentLocale;
    return /*#__PURE__*/_react.default.createElement(CardCVStyled, null, /*#__PURE__*/_react.default.createElement(ImgStyled, null, /*#__PURE__*/_react.default.createElement(_atoms.Avatar, {
      src: avatarURL,
      kind: "image",
      name: nome
    }), ((acoes == null ? void 0 : acoes.avaliacao_id) || [-1, 1, 2, 3].includes(candidatura == null ? void 0 : candidatura.avaliacao)) && /*#__PURE__*/_react.default.createElement(ReactionStyled, null, candidatura != null && candidatura.avaliacao ? /*#__PURE__*/_react.default.createElement("img", {
      src: rating.find(function (v) {
        return v.value === candidatura.avaliacao;
      }).image // TO DO
      // alt={intl.get('FILTROS.AVALIACAO.IMAGEM')}

    }) : /*#__PURE__*/_react.default.createElement(_atoms.RatingEmojis, {
      kind: acoes == null ? void 0 : acoes.avaliacao_id,
      size: "medium"
    }))), /*#__PURE__*/_react.default.createElement(Visualized, {
      "data-visualized": "true"
    }), /*#__PURE__*/_react.default.createElement(InfosStyled, null, /*#__PURE__*/_react.default.createElement(NameStyled, null, nome), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: ultima_experiencia
    }, /*#__PURE__*/_react.default.createElement(_atoms.TextWithIcon, null, /*#__PURE__*/_react.default.createElement(_atoms.IconStyles, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "building"
    })), /*#__PURE__*/_react.default.createElement(BoldName, null, ultima_experiencia == null ? void 0 : ultima_experiencia.cargo, " "), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: ultima_experiencia == null ? void 0 : ultima_experiencia.empresa
    }, "em ", ultima_experiencia == null ? void 0 : ultima_experiencia.empresa))), ultimo_curso != null && ultimo_curso.nome ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_atoms.TextWithIcon, null, /*#__PURE__*/_react.default.createElement(_atoms.IconStyles, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "book"
    })), ultimo_curso != null && ultimo_curso.nome ? ultimo_curso.nome + ' em ' : '', ultimo_curso != null && ultimo_curso.instituicao ? ultimo_curso.instituicao : '')) : nivel_de_escolaridade != null && nivel_de_escolaridade.descricao ? /*#__PURE__*/_react.default.createElement(_atoms.TextWithIcon, null, /*#__PURE__*/_react.default.createElement(_atoms.IconStyles, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "book"
    })), nivel_de_escolaridade == null ? void 0 : nivel_de_escolaridade.descricao) : nivel_de_escolaridade ? /*#__PURE__*/_react.default.createElement(_atoms.TextWithIcon, null, /*#__PURE__*/_react.default.createElement(_atoms.IconStyles, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "book"
    })), nivel_de_escolaridade) : null, (salario_atual == null ? void 0 : salario_atual.valor) !== 0 && (salario_atual == null ? void 0 : salario_atual.moeda) && /*#__PURE__*/_react.default.createElement(_atoms.TextWithIcon, null, /*#__PURE__*/_react.default.createElement(_atoms.IconStyles, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "dollar-circle"
    })), salario_atual != null && salario_atual.valor ? (_salario_atual$valor = salario_atual.valor) == null ? void 0 : _salario_atual$valor.toLocaleString(currentLocale, {
      style: 'currency',
      currency: salario_atual == null ? void 0 : salario_atual.moeda
    }) : null), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: !!(pcd != null && pcd.status)
    }, /*#__PURE__*/_react.default.createElement(StyledPcd, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "handicap"
    }), /*#__PURE__*/_react.default.createElement("span", null, "PCD"))), (acoes == null ? void 0 : acoes.marcadores) && /*#__PURE__*/_react.default.createElement(_atoms.LabelRows, null, acoes == null ? void 0 : (_acoes$marcadores = acoes.marcadores) == null ? void 0 : _acoes$marcadores.map(function (label, index) {
      return /*#__PURE__*/_react.default.createElement(_atoms.Label, {
        key: index
      }, label, /*#__PURE__*/_react.default.createElement(_atoms.Spacing, {
        horizontal: true
      }));
    })), dentro_do_perfil && dentro_do_perfil === true && /*#__PURE__*/_react.default.createElement(RecommendedTag, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "like"
    }), " Inclu\xEDdo no processo")));
  };

  MiniCV.defaultProps = {
    miniCVData: {},
    avatarURL: '',
    currentLocale: 'pt_BR'
  };
  var _default = MiniCV;
  _exports.default = _default;
});